import Vue from "vue";
import VueRouter from "vue-router";
//首页
import Home from "../pages/home/index.vue"; /* 首页 */
import Mine from "../pages/mine/index.vue"; /* 我的 */
import Choose from "../pages/choose/index.vue"; /* 选妃 */
import Profile from "../pages/choose/profile.vue"; /* 选妃详情 */
import Video from "../pages/video/index.vue"; /* 视频 */
import Login from "../pages/login/index.vue"; /* 登录 */
import Register from "../pages/login/register.vue"; /* 注册 */
import SetPayPassword from "../pages/mine/SetPayPassword.vue"; /* 修改提现密码 */
import SetLoginPassword from "../pages/mine/SetLoginPassword.vue"; /* 修改提现密码 */
import Lottery from "../pages/lottery/index.vue"; /* 刷单首页 */
import FakeTransactionsList from "../pages/lottery/fakeTransactionsList.vue"; /* 刷单交易列表 */
import FakeTransactionsDetail from "../pages/lottery/fakeTransactionsDetail.vue"; /* 酒店详情 */
import Notice from "../pages/mine/Notice.vue"; /* 公告 */
import Setbank from "../pages/mine/Setbank"; /* 视频播放页面 */
import BindCard from "../pages/mine/BindCard"; /* 绑定银行卡界面 */
import Withdraw from "../pages/mine/Withdraw"; /* 绑定银行卡界面 */
import Fundingdetails from "../pages/mine/Fundingdetails"; /* 资金明细 */
import SwitchLanguage from "../pages/switchLanguage/switchLanguage"; /* 切换语言 */
import customerservice from "../pages/mine/customerservice"; /* 在线客服列表 */
import Mall from "../pages/mine/Mall"; /* 爱巢商城 */
import MallDetail from "../pages/mine/MallDetail"; /* 爱巢商城详情 */
import MallOrder from "../pages/mine/MallOrder"; /* 爱巢商城订单 */

Vue.use(VueRouter);
const routes = [
  { path: "/", redirect: "/Home", component: Home, meta: { title: "" } },
  { path: "/Home", name: "home", component: Home, meta: { title: "" } },
  {
    path: "/Lottery",
    name: "Lottery",
    component: Lottery,
    meta: { title: "" },
  },
  {
    path: "/FakeTransactionsList",
    name: "FakeTransactionsList",
    component: FakeTransactionsList,
    meta: { title: "" },
  },
  {
    path: "/FakeTransactionsDetail",
    name: "FakeTransactionsDetail",
    component: FakeTransactionsDetail,
    meta: { title: "" },
  },
  {
    path: "/Choose",
    name: "choose",
    component: Choose,
    meta: { title: "" },
  },
  {
    path: "/Profile",
    name: "profile",
    component: Profile,
    meta: { title: "" },
  },
  { path: "/Mine", name: "mine", component: Mine, meta: { title: "" } },
  { path: "/Video", name: "video", component: Video, meta: { title: "" } },
  { path: "/Login", name: "login", component: Login, meta: { title: "" } },
  {
    path: "/Register",
    name: "register",
    component: Register,
    meta: { title: "" },
  },
  {
    path: "/SetPayPassword",
    name: "SetPayPassword",
    component: SetPayPassword,
    meta: { title: "" },
  },
  {
    path: "/SetLoginPassword",
    name: "SetLoginPassword",
    component: SetLoginPassword,
    meta: { title: "" },
  },
  {
    path: "/Notice",
    name: "Notice",
    component: Notice,
    meta: { title: "" },
  },
  {
    path: "/Setbank",
    name: "Setbank",
    component: Setbank,
    meta: { title: "" },
  },
  {
    path: "/Mall",
    name: "Mall",
    component: Mall,
    meta: { title: "" },
  },
  {
    path: "/MallDetail",
    name: "MallDetail",
    component: MallDetail,
    meta: { title: "" },
  },
  {
    path: "/MallOrder",
    name: "MallOrder",
    component: MallOrder,
    meta: { title: "" },
  },
  {
    path: "/BindCard",
    name: "BindCard",
    component: BindCard,
    meta: { title: "" },
  },
  {
    path: "/Withdraw",
    name: "Withdraw",
    component: Withdraw,
    meta: { title: "" },
  },
  {
    path: "/Fundingdetails",
    name: "Fundingdetails",
    component: Fundingdetails,
    meta: { title: "" },
  },
  {
    path: "/SwitchLanguage",
    name: "SwitchLanguage",
    component: SwitchLanguage,
    meta: { title: "" },
  },
  {
    path: "/customerservice",
    name: "customerservice",
    component: customerservice,
    meta: { title: "" },
  },
];

//生成路由实例
const router = new VueRouter({
  routes,
});
router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  next();
});

export default router;
